import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Error.svg?component
var Error_exports = /* @__PURE__ */ __exportAll({
	default: () => Error_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M12 17.6c-.2 0-.4-.2-.4-.4s.2-.4.4-.4m0 .8c.2 0 .4-.2.4-.4s-.2-.4-.4-.4m0-3V5.6" }, null, -1), createElementVNode("path", { d: "M12 22c5.5 0 10-4.5 10-10S17.5 2 12 2 2 6.5 2 12s4.5 10 10 10" }, null, -1)])]);
}
var Error_default = { render: render$1 };
//#endregion
export { Error_exports, Error_default as default, render$1 as render };

//# sourceMappingURL=Error.svg.virtual.js.map